export default __webpack_public_path__ + "static/media/27.ebd96405.jpg";